export default {"src":"/_next/static/media/ellipse2.d1140655.svg","height":176,"width":176};